import React from 'react';
import Modal from '../../../components/Modal';

// The review queue (mirrors the duty-roster ReviewListModal). Lists every visit
// that needs manager review — missed visits and visits whose actual clocked
// time differs from the schedule — scoped to one zone or the whole board.
const ReviewListModal = ({ open, items = [], scopeName, onPick, onClose }) => (
  <Modal
    isOpen={open}
    onClose={onClose}
    title="Items needing review"
    maxWidth="max-w-[620px]"
  >
    {items.length === 0 ? (
      <p className="py-6 text-center text-[13px] text-[#94A3B8] dark:text-gray-500">Nothing needs review here. 🎉</p>
    ) : (
      <div className="space-y-2 pt-1">
        <p className="mb-1 text-[12px] text-[#64748B] dark:text-gray-400">
          {items.length} item{items.length === 1 ? '' : 's'} need review{scopeName ? ` in ${scopeName}` : ''}.
        </p>
        <ul className="max-h-[60vh] space-y-2 overflow-y-auto pr-1">
          {items.map((it, i) => {
            const isMissed = it.kind === 'missed';
            return (
              <li key={`${it.carer.id}-${it.visit.assignment_id}-${i}`}
                className={`flex items-center gap-3 rounded-xl border px-3 py-2.5 ${isMissed ? 'border-rose-200 bg-rose-50/50' : 'border-amber-200 bg-amber-50/50 dark:border-amber-900/50 dark:bg-amber-900/10'}`}>
                <span className="grid h-9 w-9 flex-shrink-0 place-items-center rounded-full bg-blue-100 dark:bg-blue-900/20 text-xs font-bold text-blue-700 dark:text-blue-400">{it.carer.initials}</span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-[13px] font-bold text-[#1E293B] dark:text-gray-200">{it.carer.name}</p>
                  <p className="truncate text-[11px] text-[#64748B] dark:text-gray-400">
                    {it.visit.resident?.name || it.visit.package_name} · {it.visit.start}{it.visit.end ? `–${it.visit.end}` : ''} · {it.zone.name}
                  </p>
                </div>
                <span className={`rounded px-2 py-1 text-[9px] font-extrabold uppercase tracking-wide ${isMissed ? 'bg-rose-100 text-rose-700' : 'bg-amber-100 text-amber-700 dark:bg-amber-900/10 dark:text-amber-400'}`}>
                  {isMissed ? 'Missed' : 'Differs'}
                </span>
                <button
                  onClick={() => onPick(it)}
                  className="whitespace-nowrap rounded-lg bg-[#2563EB] px-3 py-1.5 text-[11px] font-bold text-white transition hover:bg-blue-700"
                >
                  Review
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    )}
  </Modal>
);

export default ReviewListModal;
